/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptions(value) {
    if (!('GetPlayerSignature' in value) || value['GetPlayerSignature'] === undefined)
        return false;
    if (!('EnvironmentI18nLang' in value) || value['EnvironmentI18nLang'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GetPlayerSignature': json['GetPlayerSignature'],
        'EnvironmentI18nLang': json['EnvironmentI18nLang'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GetPlayerSignature': value['GetPlayerSignature'],
        'EnvironmentI18nLang': value['EnvironmentI18nLang'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoYandexGamesLoginOptions.js.map